import React, { useEffect } from "react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostAuthGhlMutation } from "@/store/rest_api";

const GhlCallback = () => {
  const { setPage, setSection } = useBreadcrumbs();
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const [postAuthGhl, postAuthGhlResponse] = usePostAuthGhlMutation();

  useEffect(() => {
    setSection("Integrations");
    setPage("GoHighLevel");
  }, []);

  useEffect(() => {
    const authzCode = queryParams.get("code");
    const integrationId = queryParams.get("state");
    if (authzCode && integrationId) {
      postAuthGhl({ code: authzCode, integrationId });
    }
  }, []);

  useEffect(() => {
    if (postAuthGhlResponse.isError || postAuthGhlResponse.isSuccess) {
      const timer = setTimeout(() => {
        navigate("/integrations");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [postAuthGhlResponse.isError, postAuthGhlResponse.isSuccess]);

  if (postAuthGhlResponse.isSuccess) {
    return <div>Success! Redirecting...</div>;
  }

  if (postAuthGhlResponse.isError) {
    return <div>Failure, redirecting... </div>;
  }

  return <div>GoHighLevel callback</div>;
};

export default GhlCallback;
